<template>
    <v-content>
        <v-container>
            <v-window v-model="step">
                <v-window-item :value="1">
                    <v-card flat>
                        <v-card-title>
                            Events
                        </v-card-title>
                        <v-card-text v-if="events">
                            <v-list two-line>
                                <template>
                                    <v-list-item  v-for="p in events" :key="p.id" v-if="p.show" @click="setEvent(p)" >
                                        <v-list-item-avatar tile>
                                            <img :src="p.imgurl" />
                                        </v-list-item-avatar>
                                        <v-list-item-content  >
                                            <v-list-item-title>{{p.name}}</v-list-item-title>
                                            <v-list-item-subtitle v-text="p.description"></v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <!--@click="viewreg(p)"-->
                                            <v-btn icon ripple color="rgb(10,10,10)"  v-if="(p.eventtype==='tourney' && p.teamsize===2) || p.id===149">
                                                <v-icon>far fa-list-alt</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                    </v-card>
                    <v-dialog v-model="eventviewdialog" :fullscreen="$vuetify.breakpoint.xs" max-width="500" scrollable>
                        <EventCard
                                v-if="activeevent"
                                :event="activeevent.event"
                                :skus="skus"
                                @close="eventviewdialog=false"
                                @register="$router.push('/eventbyid')"
                        />
                        <!--@register="step++"-->
                    </v-dialog>
                </v-window-item>
                <v-window-item :value="2">
                    <EventRegistration
                            v-if="loggedIn && product"
                            :apiendpoint="$store.state.url"
                            :skus="skus"
                            :product="product"
                            :activeevent="activeevent"
                            :key="activeproduct"
                            @cancel="step--"
                            :triggerflow="(step===2)?true:false"
                    />
                </v-window-item>
            </v-window>
        </v-container>
    </v-content>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
    import EventRegistration from "@/components/event/EventRegistration";
    import EventCard from "@/components/event/EventCard.vue";
  import EventById from "../components/event/EventById";
    export default {
        components: {EventById, EventCard, EventRegistration},
        name: "Programs",
        data() {
            return {
                show:true,
                activeproduct:false,
                skus:[],
                step:1,
                product:false,
                eventviewdialog:false
            }
        },
        computed:{
          ...mapState(['events','activeevent']),
          loggedIn(){
            return this.$store.getters['cognito/isLoggedIn'];
          },
        },
        mounted() {

        },
        methods: {
          ...mapActions(['post',  'get', 'delete', 'put']),
          ...mapMutations(['setActiveEvent']),
          createOrder(item){
                if(!this.custId)return;
                let em = this;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'orgkey': em.$store.state.orgkey
                };
                let data = {
                    custId:this.custId,
                    items:[item]
                }
                let args = {
                    headers:headers,
                    method:'post',
                    body:JSON.stringify(data)
                };
                fetch(this.$store.state.url+'api/payments/stripe/createorder',args)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log(response)
                    })
            },
          setEvent(event){
              console.log(event)
              this.setActiveEvent({event:event});
              this.eventviewdialog=true;
              this.getEvent(event.id)
            },
          viewreg(event){
                this.$store.commit('setActiveEvent',event)
                this.$router.push('/registrationlist/'+event.id+'/'+event.teamsize)
            },
          async getEvent(id) {
            let data = await this.get({path: 'api/event/json/'+id})
            if(data.error)return console.log(data.error)
            //this.activeevent = data.event
            this.setActiveEvent(data)
            //this.skus = data.skus
            //this.product = data.product
          },
        }
    }
</script>

<style scoped>
    .ol{
        border:solid thin green
    }
</style>